import React from "react";

import "./Dropdown.scss";

export type DropdownProps = {
  opt: {
    value: string;
    text?: string;
  }[];

  defaultText?: string;
  change: React.ChangeEventHandler<HTMLSelectElement>;
  defaultValue?: string;
  cx?: string;
  init?: string;
};

export const Dropdown: React.FC<DropdownProps> = ({
  opt,
  defaultText,
  change,
  defaultValue,
  cx = "",
  init,
}) => {
  return (
    <select
      className={`Dropdown ${cx}`}
      onChange={change}
      value={init}
      defaultValue={defaultValue}
    >
      {defaultText && <option value="">{defaultText}</option>}
      {opt.map((i) => (
        <option value={i.value} key={"dropdown-" + i.value}>
          {i.text || i.value}
        </option>
      ))}
    </select>
  );
};
